import { render, staticRenderFns } from "./WidgetText.vue?vue&type=template&id=8429fd46&scoped=true&"
import script from "./WidgetText.vue?vue&type=script&lang=js&"
export * from "./WidgetText.vue?vue&type=script&lang=js&"
import style0 from "./WidgetText.vue?vue&type=style&index=0&id=8429fd46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8429fd46",
  null
  
)

export default component.exports